import allloginRoutes, {
  DefaultLoginRoute,
  LoginRoute,
  ForgotPasswordRoute,
  ResetPasswordRoute,
} from "../modules/Registration/loginroutes";

import allticketRoutes, {
  TicketsManagementpage,
  ViewButton,
} from "../modules/TicketManagement/ticketroutes";

import allProjectsRoutes, {
  ProjectsListRoute,
} from "../modules/Projects/projectsroutes";

import allCorrespondenceRoutes, {
  LetterTrackingRoute,
  LetterExchangePageRoute,
} from "../modules/CorrespondenceLetters/correspondenceroutes";

import allSiteSubcompanyRoutes, {
  SiteSubcompanyRoute,
} from "../modules/SubCompany/subcompanyroutes";

import UserDashboard from "../pages/userDashboard/User_Dashboard";
import AdminDashboard from "../pages/adminDashboard/Admin_Dashboard";
import SuperAdminDashboard from "../pages/superDashboard/Super_Dashboard";
import allEmployeeRoutes, {
  EmployeeManagementRoute,
} from "../modules/EmployeeManagement/EmployeeRoutes";

import allLetterRoutes, {
  LetterManagementRoute,
} from "../modules/AllLetterDetail/allletterroutes";

import alldashboardRoutes, {
  dashboardListRoute
} from "../modules/AnalyticsDashboard/Analyticsroutes";

export const routingData = [
  {
    role: "",
    isProtected: false,
    defaultRoute: "/",
    routes: [
      // login routes
      DefaultLoginRoute,
      LoginRoute,
      ForgotPasswordRoute,
      ResetPasswordRoute,
      ...(allloginRoutes.length > 0 ? allloginRoutes : []),

      // ticket management start
      TicketsManagementpage,
      ...(allticketRoutes.length > 0 ? allticketRoutes : []),
      ViewButton,

      // Correspondance Letter Exchange
      LetterExchangePageRoute,

      // letter detail routes
      LetterManagementRoute,
      ...(allLetterRoutes.length > 0 ? allLetterRoutes : []),
    ],
  },

  // Super Admin
  {
    role: "SuperAdmin",
    isProtected: true,
    defaultRoute: "superadmin/projectsList",
    nestedRoutes: [
      {
        routes: [
          // Project Management
          ProjectsListRoute,
          ...(allProjectsRoutes.length > 0 ? allProjectsRoutes : []),
          dashboardListRoute,
          ...(alldashboardRoutes.length > 0 ? alldashboardRoutes : []),
          // Correspondance Management
          LetterTrackingRoute,
          ...(allCorrespondenceRoutes.length > 0
            ? allCorrespondenceRoutes
            : []),
          LetterExchangePageRoute,
          ...(allCorrespondenceRoutes.length > 0
            ? allCorrespondenceRoutes
            : []),

          SiteSubcompanyRoute,
          ...(allSiteSubcompanyRoutes.length > 0
            ? allSiteSubcompanyRoutes
            : []),

          EmployeeManagementRoute,
          ...(allEmployeeRoutes.length > 0 ? allEmployeeRoutes : []),
        ],
        path: "superAdmin",
        component: <SuperAdminDashboard />,
      },
    ],
  },
  // Admin
  {
    role: "Admin",
    isProtected: true,
    defaultRoute: "admin/projectsList",
    nestedRoutes: [
      {
        routes: [
          // Project Management
          ProjectsListRoute,
          ...(allProjectsRoutes.length > 0 ? allProjectsRoutes : []),
          dashboardListRoute,
          ...(alldashboardRoutes.length > 0 ? alldashboardRoutes : []),
          // Correspondance Management
          LetterTrackingRoute,
          ...(allCorrespondenceRoutes.length > 0
            ? allCorrespondenceRoutes
            : []),

          SiteSubcompanyRoute,
          ...(allSiteSubcompanyRoutes.length > 0
            ? allSiteSubcompanyRoutes
            : []),

          LetterManagementRoute,
          ...(allLetterRoutes.length > 0 ? allLetterRoutes : []),

          SiteSubcompanyRoute,
          ...(allSiteSubcompanyRoutes.length > 0
            ? allSiteSubcompanyRoutes
            : []),

          EmployeeManagementRoute,
          ...(allEmployeeRoutes.length > 0 ? allEmployeeRoutes : []),
        ],
        path: "admin",
        component: <AdminDashboard />,
      },
    ],
  },

  // Employee
  {
    role: "Employee",
    isProtected: true,
    defaultRoute: "employee/projectsList",
    nestedRoutes: [
      {
        routes: [
          // Project Management
          ProjectsListRoute,
          ...(allProjectsRoutes.length > 0 ? allProjectsRoutes : []),

          // Correspondance Management
          LetterTrackingRoute,
          ...(allCorrespondenceRoutes.length > 0
            ? allCorrespondenceRoutes
            : []),
        ],
        path: "employee",
        component: <UserDashboard />,
      },
    ],
  },
];
